module.exports = __webpack_public_path__ + "assets/img/C-1.9f59ecfd.jpg";